import { useEffect, useMemo, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { calculateAnalytics } from '../utils/analytics';

// enabled=false salta las 3 suscripciones sin filtro (claimRecords, checks,
// operatorDebts) — firestore.rules solo autoriza un query SIN where() sobre
// esas colecciones para admin; un ajustador recibiría permission-denied al
// instante. Necesario desde que Dashboard.jsx (antes admin-only) también
// monta para el rol ajustador (fusión de panel único 2026-09-21).
export default function useAnalytics(enabled = true) {
  const [attempt, setAttempt] = useState(0);
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [clientInvoicesError, setClientInvoicesError] = useState(null);
  useEffect(() => {
    if (!enabled) return;
    setError(null);
    setClientInvoicesError(null);
    const listen = (name, onError) => onSnapshot(collection(db, name), snapshot => {
      setData(previous => ({ ...previous, [name]: snapshot.docs.map(item => ({ ...item.data(), id: item.id })) }));
    }, onError);
    const stops = ['claimRecords', 'checks', 'operatorDebts'].map(name => listen(name, setError));
    // clientInvoices tiene su propio error: si falla (p. ej. reglas sin
    // publicar), el panel de facturas lo muestra y el resto de Analytics sigue.
    stops.push(listen('clientInvoices', setClientInvoicesError));
    return () => stops.forEach(stop => stop());
  }, [attempt, enabled]);
  const stats = useMemo(() => calculateAnalytics(data.claimRecords, data.checks, data.operatorDebts, data.clientInvoices), [data]);
  return { refresh: () => setAttempt(value => value + 1), stats, claims: data.claimRecords || [], operatorDebts: data.operatorDebts || [], error,
    clientInvoices: data.clientInvoices || [], clientInvoicesError, clientInvoicesLoading: enabled && !clientInvoicesError && !data.clientInvoices,
    loading: enabled && !error && (!data.claimRecords || !data.checks || !data.operatorDebts) };
}
